/* ============================================================
   WOOMN Homepage — Carousel + Interactions
   ============================================================ */
(function () {
  'use strict';

  /* ================================================================
     1. HERO CAROUSEL
     ================================================================ */
  function WoomnCarousel(el) {
    var track = el.querySelector('.woomn-carousel-track');
    var slides = el.querySelectorAll('.woomn-carousel-slide');
    if (!track || slides.length < 2) return;

    var wrap     = el.parentElement;
    var dotsWrap = wrap ? wrap.querySelector('.woomn-carousel-dots') : null;
    var delay    = parseInt(el.getAttribute('data-delay') || '4000', 10);
    var total    = slides.length;
    var current  = 0;
    var timer    = null;
    var startX   = 0;
    var deltaX   = 0;
    var dragging = false;

    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      for (var k = 0; k < total; k++) {
        (function (idx) {
          var btn = document.createElement('button');
          btn.className = 'woomn-carousel-dot' + (idx === 0 ? ' is-active' : '');
          btn.type = 'button';
          btn.setAttribute('aria-label', 'Slide ' + (idx + 1));
          btn.addEventListener('click', function () { go(idx); restart(); });
          dotsWrap.appendChild(btn);
        })(k);
      }
    }

    function updateDots() {
      if (!dotsWrap) return;
      var dots = dotsWrap.querySelectorAll('.woomn-carousel-dot');
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === current);
      }
    }

    function go(idx) {
      current = ((idx % total) + total) % total;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      updateDots();
    }

    function restart() {
      clearInterval(timer);
      timer = setInterval(function () { go(current + 1); }, delay);
    }

    el.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      deltaX = 0;
      dragging = true;
      clearInterval(timer);
      track.style.transition = 'none';
    }, { passive: true });

    el.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      deltaX = e.touches[0].clientX - startX;
    }, { passive: true });

    el.addEventListener('touchend', function () {
      if (!dragging) return;
      dragging = false;
      track.style.transition = '';
      if (Math.abs(deltaX) > 40) {
        go(deltaX < 0 ? current + 1 : current - 1);
      } else {
        go(current);
      }
      restart();
    });

    el.addEventListener('mouseenter', function () { clearInterval(timer); });
    el.addEventListener('mouseleave', restart);
    restart();
  }

  /* ================================================================
     2. HEADER
     ================================================================ */
  function initHeader() {
    return;
  }

  /* ================================================================
     3. BOTTOM NAV — highlight active link (best-match logic)

     Problem solved: when two nav items share the same URL (e.g.
     "Categories" and "All Collection" both pointing to /collections),
     the OLD code highlighted both. The NEW logic picks ONE winner:

     Step 1 — Exact match: find items whose href === current path.
              If multiple items share the same href, only the FIRST
              one found (leftmost in the nav) wins.

     Step 2 — Prefix match (fallback): if no exact match found,
              highlight the item whose href is the longest prefix of
              the current path (e.g. /collections matches when on
              /collections/luxury if no exact match exists).
              "/" is excluded from prefix matching to avoid Home
              always being active.

     Result: exactly ONE item is ever highlighted at a time.
     ================================================================ */
  function initNav() {
    var nav = document.querySelector('.woomn-bottom-nav');
    if (!nav) return;

    var path  = window.location.pathname.replace(/\/$/, '') || '/';
    var items = nav.querySelectorAll('.woomn-nav-item');

    /* Step 1: exact match — first-wins when URLs are identical */
    var exactWinner = null;
    for (var i = 0; i < items.length; i++) {
      var href = (items[i].getAttribute('href') || '').replace(/\/$/, '') || '/';
      if (href === path) {
        exactWinner = items[i];
        break; /* stop at the FIRST match so duplicates are ignored */
      }
    }

    if (exactWinner) {
      exactWinner.classList.add('woomn-nav-active');
      return;
    }

    /* Step 2: prefix match — longest matching prefix wins */
    var prefixWinner = null;
    var prefixLen    = -1;
    for (var j = 0; j < items.length; j++) {
      var hrefJ = (items[j].getAttribute('href') || '').replace(/\/$/, '') || '/';
      if (hrefJ !== '/' && path.startsWith(hrefJ + '/') && hrefJ.length > prefixLen) {
        prefixWinner = items[j];
        prefixLen    = hrefJ.length;
      }
    }

    if (prefixWinner) {
      prefixWinner.classList.add('woomn-nav-active');
      return;
    }

    /* Step 3: fallback — home gets highlighted on ‘/’ */
    if (path === '/' && items[0]) {
      items[0].classList.add('woomn-nav-active');
    }
  }

  /* ================================================================
     3b. BOTTOM NAV — scroll-aware hide/show
     ================================================================ */
  function initBottomNavScroll() {
    var nav = document.querySelector('.woomn-bottom-nav');
    if (!nav) return;

    var lastY        = window.pageYOffset;
    var raf          = null;
    var JITTER       = 3;
    var DOWN_HIDE_AT = 130;
    var downAccum    = 0;

    function update() {
      var y    = window.pageYOffset;
      var diff = y - lastY;

      if (y <= 0) {
        downAccum = 0;
        nav.classList.remove('woomn-bottom-nav--hidden');
      } else if (diff > JITTER) {
        downAccum += diff;
        if (downAccum > DOWN_HIDE_AT) {
          nav.classList.add('woomn-bottom-nav--hidden');
        }
      } else if (diff < -JITTER) {
        downAccum = 0;
        nav.classList.remove('woomn-bottom-nav--hidden');
      }

      lastY = y;
      raf   = null;
    }

    window.addEventListener('scroll', function () {
      if (!raf) raf = requestAnimationFrame(update);
    }, { passive: true });
  }

  /* ================================================================
     3c. TOP STORIES carousel
     ================================================================ */
  function initStoriesCarousel() {
    var scrollers = document.querySelectorAll('.woomn-stories-scroll');
    for (var c = 0; c < scrollers.length; c++) {
      (function (scroller) {
        var cards = scroller.querySelectorAll('.woomn-story-card');
        if (!cards.length) return;

        var wrap     = scroller.parentElement;
        var dotsWrap = wrap ? wrap.querySelector('.woomn-stories-dots') : null;
        var total    = cards.length;
        var raf      = null;

        if (dotsWrap) {
          dotsWrap.innerHTML = '';
          for (var i = 0; i < total; i++) {
            (function (idx) {
              var dot = document.createElement('button');
              dot.type = 'button';
              dot.className = 'woomn-stories-dot' + (idx === 0 ? ' is-active' : '');
              dot.setAttribute('aria-label', 'Story ' + (idx + 1));
              dot.addEventListener('click', function () {
                cards[idx].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
              });
              dotsWrap.appendChild(dot);
            })(i);
          }
        }

        function updateActive() {
          if (!dotsWrap) { raf = null; return; }
          var center      = scroller.scrollLeft + scroller.clientWidth / 2;
          var closest     = 0;
          var closestDist = Infinity;
          for (var i = 0; i < total; i++) {
            var cardCenter = cards[i].offsetLeft + cards[i].offsetWidth / 2;
            var dist = Math.abs(cardCenter - center);
            if (dist < closestDist) { closestDist = dist; closest = i; }
          }
          var dots = dotsWrap.querySelectorAll('.woomn-stories-dot');
          for (var d = 0; d < dots.length; d++) {
            dots[d].classList.toggle('is-active', d === closest);
          }
          raf = null;
        }

        scroller.addEventListener('scroll', function () {
          if (!raf) raf = requestAnimationFrame(updateActive);
        }, { passive: true });
      })(scrollers[c]);
    }
  }

  /* ================================================================
     3d. FOOTER 3D BAG reveal
     ================================================================ */
  function initBagReveal() {
    var els = document.querySelectorAll('.woomn-footer-bag-wrap');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < els.length; i++) { els[i].classList.add('is-visible'); }
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });
    for (var j = 0; j < els.length; j++) { observer.observe(els[j]); }
  }

  /* ================================================================
     3e. BRAND GALLERY carousel
     ================================================================ */
  function initBrandGallery() {
    var scrollers = document.querySelectorAll('.woomn-brandgallery-scroll');
    for (var c = 0; c < scrollers.length; c++) {
      (function (scroller) {
        var cols = scroller.querySelectorAll('.woomn-brand-col');
        if (!cols.length) return;
        var wrap     = scroller.parentElement;
        var dotsWrap = wrap ? wrap.querySelector('.woomn-brandgallery-dots') : null;
        var total    = cols.length;
        var raf      = null;
        if (dotsWrap) {
          dotsWrap.innerHTML = '';
          for (var i = 0; i < total; i++) {
            (function (idx) {
              var dot = document.createElement('button');
              dot.type = 'button';
              dot.className = 'woomn-brandgallery-dot' + (idx === 0 ? ' is-active' : '');
              dot.setAttribute('aria-label', 'Brand ' + (idx + 1));
              dot.addEventListener('click', function () {
                cols[idx].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
              });
              dotsWrap.appendChild(dot);
            })(i);
          }
        }
        function updateActive() {
          if (!dotsWrap) { raf = null; return; }
          var center      = scroller.scrollLeft + scroller.clientWidth / 2;
          var closest     = 0;
          var closestDist = Infinity;
          for (var i = 0; i < total; i++) {
            var colCenter = cols[i].offsetLeft + cols[i].offsetWidth / 2;
            var dist = Math.abs(colCenter - center);
            if (dist < closestDist) { closestDist = dist; closest = i; }
          }
          var dots = dotsWrap.querySelectorAll('.woomn-brandgallery-dot');
          for (var d = 0; d < dots.length; d++) {
            dots[d].classList.toggle('is-active', d === closest);
          }
          raf = null;
        }
        scroller.addEventListener('scroll', function () {
          if (!raf) raf = requestAnimationFrame(updateActive);
        }, { passive: true });
      })(scrollers[c]);
    }
  }

  /* ================================================================
     4. INIT
     ================================================================ */
  function init() {
    var carousels = document.querySelectorAll('.woomn-hero-carousel');
    for (var i = 0; i < carousels.length; i++) { WoomnCarousel(carousels[i]); }
    initHeader();
    initNav();
    initBottomNavScroll();
    initStoriesCarousel();
    initBagReveal();
    initBrandGallery();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target || (e.detail && e.detail.target);
    if (!s) return;
    var carousels = s.querySelectorAll('.woomn-hero-carousel');
    for (var i = 0; i < carousels.length; i++) { WoomnCarousel(carousels[i]); }
    if (s.querySelector('.woomn-bottom-nav')) { initNav(); initBottomNavScroll(); }
    if (s.querySelector('.woomn-header-section')) initHeader();
    if (s.querySelector('.woomn-stories-scroll')) initStoriesCarousel();
    if (s.querySelector('.woomn-footer-bag-wrap')) initBagReveal();
    if (s.querySelector('.woomn-brandgallery-scroll')) initBrandGallery();
  });

})();
